<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div class="actions">
  <button mat-button color="warn" (click)="data.delete_callback(data.report, $event, dialogRef)" [mat-dialog-close]="'delete'">{{data.confirm_button}}</button>
  <button mat-button (click)="data.cancel_callback(data.report, $event, dialogRef, data.div)" [mat-dialog-close]="'cancel'" cdkFocusInitial>Cancel</button>
</div>
